// model control

page.control.models.godrays.fadeTo = function(c, t){
    if(typeof(c) != "number") return;
    if(typeof(t) != "number") t = 1000;
    log.webgl(`GODRAYS: FadeTo(${c}, ${t})`, 2);
    c = Math.clamp(c, 0, 1);
    var v = page.v.models.godrays;

    v.aStart = page.control.models.godrays.alpha;
    v.aTarget = c;
    v.aVal = 0;
    v.aStep = 1 / t;
}

page.control.models.fadeTo = function(c, t){
    if(typeof(c) != "number") return;
    if(typeof(t) != "number") t = 1000;
    log.webgl(`MODELS: FadeTo(${c}, ${t})`, 2);
    c = Math.clamp(c, 0, 1);
    var v = page.three.v.models;

    v.aStart = v.alpha;
    v.aTarget = c;
    v.aVal = 0;
    v.aStep = 1 / t;
}


page.three.f.models.calc = function(){
    var t=page.v.time;
    var s=page.v.scroll;
    var wgl = page.three;
    var v = page.v.models.godrays;

    if(v.aVal != 1){
        v.aVal += v.aStep * t.delta;
        v.aVal = Math.clamp(v.aVal, 0, 1);
        if(v.aVal >= 1){
            page.control.models.godrays.alpha = v.aTarget;
        }else{
            page.control.models.godrays.alpha = THREE.Math.lerp(v.aStart, v.aTarget, Math.ease.outSin(v.aVal));
        }
    }
    
    v = page.three.v.models;

    if(v.aVal != 1){
        v.aVal += v.aStep * t.delta;
        v.aVal = Math.clamp(v.aVal, 0, 1);
        if(v.aVal >= 1){
            v.alpha = v.aTarget;
        }else{
            v.alpha = THREE.Math.lerp(v.aStart, v.aTarget, Math.ease.outSin(v.aVal));
        }
    }

    let tt = t.current / 1000;
    wgl.godRays.uniforms.uTime.value = tt;
    wgl.clouds.uniforms.uTime.value = t.current / 3000 + 80;
    wgl.pTanMat.uniforms.uTime.value = tt;
    wgl.lMat.uniforms.uTime.value = tt;
    wgl.tMat.uniforms.uTime.value = tt;
}